import { parseJwt } from '../utils/jwtDecoder';
import { getItem } from '../utils/authStorage';
import { fetchWithAuthRetry, getAuthHeaders, ensureValidToken } from '../utils/helpers';

const emptyMmm = {
  projectId: null,
  surveyId: null,
  surveyDate: null,
  men: { totalCount: 0, items: [] },
  machine: { items: [] },
  material: { items: [] },
};

/**
 * Fetch Men / Machine / Material summary for a project + survey.
 * GET /api/construction/projects/{numericId}/mmm?surveyId=
 */
export async function fetchMmmSummary(numericId, surveyId) {
  if (!numericId || !surveyId) return emptyMmm;

  const endpoint = `/api/construction/projects/${numericId}/mmm?surveyId=${encodeURIComponent(surveyId)}`;

  try {
    await ensureValidToken();
    const token = getItem('accessToken');
    const payload = token ? parseJwt(token) : null;
    const tenantId = payload?.tenant_id || '';

    const headers = {
      ...getAuthHeaders(),
      ...(tenantId ? { 'X-Tenant-Id': tenantId } : {}),
    };

    const response = await fetchWithAuthRetry(endpoint, { headers });
    if (response.ok) {
      const json = await response.json();
      return {
        projectId: json.projectId ?? numericId,
        surveyId: json.surveyId ?? surveyId,
        surveyDate: json.surveyDate ?? null,
        men: {
          totalCount: Number(json.men?.totalCount) || 0,
          items: Array.isArray(json.men?.items) ? json.men.items : [],
        },
        machine: {
          items: Array.isArray(json.machine?.items) ? json.machine.items : [],
        },
        material: {
          items: Array.isArray(json.material?.items) ? json.material.items : [],
        },
      };
    }
    console.warn(`GET ${endpoint} → HTTP ${response.status}`);
  } catch (err) {
    console.error(`fetchMmmSummary error (${endpoint}):`, err);
  }

  return emptyMmm;
}
